import {
  Header as SundayHeader,
  ThemeProvider as SundayThemeProvider,
} from "@sunday/component";
import { useTranslation } from "next-i18next";
import {
  ICTH_LOGO,
  ICTH_THEME,
} from "src/components/Common/ICTHLayout/constants";
import { buildICTHHeaderMenus } from "src/components/Common/ICTHLayout/navigation";
import { HeaderMenu, IHeader, Language } from "../IHeader";

type ICTHHeaderProps = Pick<
  IHeader,
  "content" | "language" | "onChangeLanguage" | "showSwitchLanguage"
> & {
  menus: HeaderMenu | undefined;
  showMenus: boolean;
};

const ICTHHeader = ({
  content,
  language,
  menus,
  onChangeLanguage,
  showMenus,
  showSwitchLanguage,
}: ICTHHeaderProps): JSX.Element => {
  const { t } = useTranslation("layout");
  const availableLanguages: Language[] =
    content?.supportedLangs?.map((lang) => lang.code as Language) || [];
  const headerMenus = showMenus
    ? buildICTHHeaderMenus({
        language,
        translate: t,
        customMenus: menus,
      })
    : [];

  return (
    <SundayThemeProvider theme={ICTH_THEME}>
      <SundayHeader
        logoSrc={ICTH_LOGO.src}
        logoHref={ICTH_LOGO.href}
        logoAlt={ICTH_LOGO.alt}
        menus={headerMenus}
        language={language}
        availableLanguages={availableLanguages}
        showLanguageSwitcher={showSwitchLanguage}
        onChangeLanguage={onChangeLanguage}
        showLoginSignup={false}
        className="icth-header"
      />
    </SundayThemeProvider>
  );
};

export default ICTHHeader;
